export default "__VITE_PUBLIC_ASSET__976acc74__"